import { i18n } from "translate/i18n";

export const muteReminder = i18n.t("messages.muteReminder");
